const { REACT_APP_BACKEND_URL, REACT_APP_ACTION_CABLE_URL } = process.env

export const BACKEND_URL = REACT_APP_BACKEND_URL
export const API_URL = BACKEND_URL + '/api'
export const ACTION_CABLE_URL = REACT_APP_ACTION_CABLE_URL + '/api/chat'
